<template>
  <div id="App">
    <loading :visible="false" />
    <template v-if="!firstLoading">
      <transition name="router-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loading from '@/components/loading';
// import * as VConsole from 'vconsole'
// new VConsole();
export default {
  name: 'app',
  components: { Loading },
  data () {
    return {
      firstLoading: false
    };
  },
  computed: {
    ...mapGetters(['hasMask', 'orderDetail'])
  },
  mounted () {
  },
  methods: {
  }
};
</script>
<style lang="scss">
#App {
  height: 100vh;
  width: 100vw;
  font-size: 0.7rem;
}
.router-fade-enter-active,
.router-fade-leave-active {
  transition: opacity 0.3s;
}
.router-fade-enter,
.router-fade-leave-to {
  opacity: 0;
}
</style>
